import { Action } from '../enums/action.enum';
import { DeviceService } from '../../services/device.service';
import { LazyLoadEvent } from '@openng/optimus-ui/api';
import { inject } from '@angular/core';

/**
 * Base container to supply common functionality.
 */
export class BaseContainer {
  protected _deviceService = inject(DeviceService);
  Action = Action;
  screenName: string = '';

  isMobile() {
    return this._deviceService.isMobile();
  }

  isNonMobile() {
    return !this._deviceService.isMobile();
  }

  /**
   * Determines if a request for a new page is available.
   * @param event
   */
  protected isAPageRequestAvailable(event: LazyLoadEvent) {
    return event.first !== null && event.first !== undefined;
  }
}
